import { buildRefreshParameters, getTabularReducerInfo } from "./common"
import { apiGet, apiPost, apiPut, apiDelete } from "../../utils/apiConnector"
import {
  inventoryApi,
  inventoryFixApi,
  reportInventoryApi,
  addMeasureApi,
} from "../../config/apiUrls"
import { createAction } from "redux-actions"
import download from "downloadjs"
import { showMessage, alertTypes } from "../alerts"

const prefix = "INVENTORY"

const defaultState = {
  inventoryId: null,
}

// Actions
const specificActions = {
  setInventoryId: createAction(prefix + "_SET_INVENTORY_ID"),
  fixInventory: createAction(prefix + "_FIX_INVENTORY"),
}

const asd = (state, { payload }) => {
  return { ...state, inventoryId: payload }
}

// Reducers
const specificReducers = {
  [specificActions.setInventoryId]: asd,
  [specificActions.fixInventory]: (state, { payload }) => ({
    ...state,
    inventoryStocks: state.data.inventoryStocks.map((i) => {
      if (i.inventoryStockId === payload.inventoryStockId) {
        i.name.fixed = payload.name
        i.salePrice.fixed = Number(payload.salePrice)
        i.remainder.fixed = Number(payload.remainder)
      }
    }),
  }),
}

// Thunk
export function addNewMeasure(data, inventoryId) {
  return (dispatch) => {
    apiPost(addMeasureApi, data)
      .onOk((res) => {
        dispatch(showMessage(res.data.response, alertTypes.success))
        dispatch(refresh({ inventoryId }))
      })
      .useDefaultErrorHandlers(dispatch)
      .startSingle()
  }
}

export function deleteFromInventory(id, inventoryId) {
  return (dispatch) => {
    apiDelete(inventoryFixApi + "?" + "invStockId=" + id)
      .onOk((res) => {
        dispatch(refresh({ inventoryId }))
      })
      .useDefaultErrorHandlers(dispatch)
      .startSingle()
  }
}

export function refresh({ inventoryId }) {
  return (dispatch, getState) => {
    const state = getState()
    dispatch(actions.setLoading(true))
    dispatch(specificActions.setInventoryId(inventoryId))
    const params = buildRefreshParameters(undefined, state.currentInventory)
    params.inventoryId = inventoryId
    return apiGet(inventoryFixApi, params)
      .onOk((res) => {
        dispatch(actions.setData(res.data.response))
        dispatch(actions.setTotalPages(res.data.response.pages))
      })
      .useDefaultErrorHandlers(dispatch)
      .afterAll(() => {
        dispatch(actions.setLoading(false))
      })
      .startSingle()
  }
}

export function editInventory(data, callback, inventoryId) {
  // eslint-disable-next-line no-empty-pattern
  return (dispatch, {}) => {
    dispatch(actions.setLoading(true))
    dispatch(specificActions.fixInventory(data))
    return apiPost(inventoryFixApi, data)
      .onOk(() => {
        dispatch(specificActions.fixInventory(data))
        dispatch(refresh({ inventoryId }))
      })
      .onFail((res) => {
        dispatch(
          specificActions.fixInventory({
            inventoryStockId: data.inventoryStockId,
          }),
        )
        return res
      })
      .useDefaultErrorHandlers(dispatch)
      .afterAll(() => {
        dispatch(actions.setLoading(false))
        callback()
      })
      .startSingle(data.inventoryStockId)
  }
}

export function closeInventory(callback) {
  return (dispatch, getState) => {
    const { inventoryId } = getState().currentInventory
    dispatch(actions.setLoading(true))
    return apiPut(inventoryApi, { id: inventoryId })
      .onOk(() => {
        callback()
      })
      .afterAll(() => {
        dispatch(actions.setLoading(false))
      })
      .startSingle()
  }
}

export function deleteInventory(callback) {
  return (dispatch, getState) => {
    const { inventoryId } = getState().currentInventory
    return apiDelete(inventoryApi, { inventoryId })
      .onOk(() => {
        callback()
      })
      .startSingle()
  }
}

export function exportData(callback) {
  return (dispatch, getState) => {
    const { inventoryId } = getState().currentInventory

    apiGet(reportInventoryApi + "/" + inventoryId, null, {
      responseType: "blob",
      headers: {
        Accept:
          "application/vnd.openxmlformats-officedocument" +
          ".spreadsheetml.sheet",
      },
    })
      .skipValidation()
      .onOk((res) => {
        download(res.data, "Инвентаризация №" + inventoryId + ".xls")
        callback()
      })
      .useDefaultErrorHandlers(dispatch)
      .startSingle()
  }
}

function buildRefreshActionParameters(getState) {
  return { inventoryId: getState().currentInventory.inventoryId }
}

const { actions, reducer, thunks } = getTabularReducerInfo(
  prefix,
  refresh,
  buildRefreshActionParameters,
  defaultState,
  specificReducers,
)
export default reducer
export const { openPage, filter, clear, search, sort } = thunks
